import React from 'react';

import Input from 'components/Input';
import { ReactComponent as EditIcon } from 'images/edit-icon.svg';

import styles from './ConfirmReapplyDetails.module.scss';

interface DisabledDetailFieldProps {
  label: string;
  value: string;
  name?: string;
  onEdit?: () => void;
}

const DisabledDetailField: React.FC<DisabledDetailFieldProps> = ({ label, value, name, onEdit }) => (
  <div className={styles.field}>
    <Input
      label={label}
      name={name}
      value={value}
      disabled
      inputClassName={onEdit ? styles.disabledInput : undefined}
    />
    {onEdit && (
      <button type="button" className={styles.editButton} onClick={onEdit} aria-label={`Edit ${label}`}>
        <EditIcon className={styles.editIcon} />
      </button>
    )}
  </div>
);

export default DisabledDetailField;
